import { Product } from "generated/graphql";
import React from "react";
import { InputCounter, OperationButton } from "../MainStyles";
import { ContainerCounterProduct } from "./CatalogStyles";

interface IVehicleCounter {
  countValue: number;
  product: Product;
  onChangeCountValue: (item: Product, counter: number) => void;
  isForDelivery?: boolean;
  maxCountValue?: number;
}
export default function ProductCounter({
  countValue,
  product,
  onChangeCountValue,
  isForDelivery = false,
  maxCountValue,
}: IVehicleCounter) {
  const onChangeValue = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>, value: number) => {
    e.preventDefault();
    const newValue = countValue + value;
    if (isForDelivery) {
      newValue >= 1 && newValue <= maxCountValue && onChangeCountValue(product, newValue);
    } else {
      newValue >= 1 && onChangeCountValue(product, newValue);
    }
  };

  const renderValue = () => (isForDelivery ? `${countValue}/${maxCountValue}` : countValue);
  return (
    <ContainerCounterProduct>
      <OperationButton
        aria-disabled={countValue <= 1}
        onClick={(e) => onChangeValue(e, -1)}
        style={{ fontSize: "16px" }}
      >
        -
      </OperationButton>
      <InputCounter value={renderValue()} disabled />
      <OperationButton
        aria-disabled={isForDelivery && countValue >= maxCountValue}
        onClick={(e) => onChangeValue(e, 1)}
        style={{ fontSize: "16px" }}
      >
        +
      </OperationButton>
    </ContainerCounterProduct>
  );
}
